module.exports = __webpack_public_path__ + "static/media/example-2.e31840ba.png";